export type DailySharePayload = {
  date: string;
  score: number;
  name?: string | null;
};

export function getDailyShareUrl(shareId: string): string | null {
  if (typeof window === 'undefined') return null;
  if (!shareId) return null;
  const url = new URL(window.location.href);
  url.search = '';
  url.hash = '';
  url.pathname = `/s/${shareId}`;
  return url.toString();
}
